import React, { FC } from 'react';
import styled from '@emotion/native';
import TextBase, { Props as TextProps } from '@components/1-atoms/Text';



const Container = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center; // vertical alignment
  justify-content: flex-start; // horizontal alignmennt

  border-radius: 3px;
  padding: 12px;

  ${props => props?.fullwidth && `
    width: ${props.theme.contentWidth}px;
  `}
  ${props => props?.inset && `
    width: ${props.theme.contentWidth - 30}px;
  `}
  ${props => props?.mini && `
    width: ${props.theme.columnWidth - 15 - 2}px;
  `}

  ${props =>  `background-color: ${props.theme.pallete.accentColor};`}
  ${(props) => props?.primary && ` background-color: #FFF;`}

  ${props => props?.bg && ` background-color: ${props?.bg};`}
  ${props => props?.disabled && `
    background-color: #CCC;
    ${props?.outlined && ` background-color: transparent; `}
  `}
  
  ${props => props?.outlined && ` background-color: #FFF; `}
  border: none;
  ${props => props?.outlined && `
    border: 1px solid ${props.theme.pallete.accentColor};
    ${props?.disabled && ` border:  1px solid #CCC; `}
  `}
  
  min-height: ${({ height, ...props }: any) => `${height || props.theme.buttonHeight}px`};
`;

// TODO: Apply blue text color for primary button
const Text = styled(TextBase)`
  // flex-grow: 15; // text take too much verticall space
  ${props =>  ` color: ${props.color || props.theme.pallete.mask}; `}
  ${(props) => props?.primary  && `color: ${props.theme.pallete.accentColor};`}
  ${props => props?.outlined && ` color: ${props.theme.pallete.accentColor}; `}
  ${props => props?.disabled && ` color: ${props.theme.pallete.white}; `}
  ${props => props?.fullwidth && ` max-width: 72.5%; `}
  
  text-align: ${({ align }: any) => (align || "center")};
`;

export const Left = styled.View`
  justify-content: flex-start;
  flex-direction: column;
  // flex-grow: 5; // for info, look Text style above
  text-align: left;
  padding-right: 9px;

  align-items: flex-start;
`;

export const Right = styled.View`
  justify-content: flex-end;
  flex-direction: column;
  // flex-grow: 5; // for info, look Text style above
  text-align: right;
  padding-left: 9px;

  align-items: flex-end;

`;

export type Props = TextProps & {
  onPress?: () => void;
  onFocus?: () => void;
  left?: any;
  right?: any;
  height?: number;
  bg?: string;
  primary?: boolean;
  fullwidth?: boolean;
  inset?: boolean;
  outlined?: boolean;
  disabled?: boolean;
  color?: string;
  children?: React.ReactNode | Text;
};


const Button: FC<Props> = ({ onPress, left, right, children, fullwidth = true, ...props }) => {
  return (
    <Container onPress={! props.disabled && onPress} fullwidth={fullwidth} {...props}>
      {left && <Left>{left}</Left>}

      <Text {...props}>{children}</Text>

      {right && <Right>{right}</Right>}
    </Container>
  );
};

export default Button;